<div class="zm-dashboard">

  <!-- ─── Header zone ─────────────────────────────────────────── -->
  <div class="zm-header">
    <div class="zm-header__left">
      <div class="zm-zone-badge">
        <i class="fal fa-map-marker-alt"></i>
      </div>
      <div class="zm-header__info">
        <h1 class="zm-header__title">
          Responsable de zone
          <span class="zm-zone-name" *ngIf="nomZone"> — {{ nomZone }}</span>
        </h1>
        <p class="zm-header__sub">
          Bonjour {{ utilisateur?.prenom ?? utilisateur?.sub ?? 'Responsable' }},
          voici l'état de votre zone en temps réel.
        </p>
      </div>
    </div>
    <button class="btn-refresh" (click)="chargerStatsDashboard(); chargerManifestes()">
      <i class="fal fa-sync"></i> Actualiser
    </button>
  </div>

  <div class="zone-info-banner" [class.zone-info-banner--warning]="zoneNonRenseignee">
    <div class="zone-info-banner__icon">
      <i class="fal" [class.fa-map-marked-alt]="!zoneNonRenseignee" [class.fa-exclamation-triangle]="zoneNonRenseignee"></i>
    </div>
    <div class="zone-info-banner__text">
      <span class="zone-info-banner__label">Zone dont vous etes responsable</span>
      <strong class="zone-info-banner__value">{{ nomZone || 'Aucune zone assignee pour votre compte' }}</strong>
    </div>
  </div>

  <!-- ─── KPIs ─────────────────────────────────────────────────── -->
  <div class="kpi-grid" *ngIf="!chargementStats && statsZone">
    <div class="kpi-card kpi--blue">
      <i class="fal fa-box-open"></i>
      <div class="kpi-body">
        <span class="kpi-val">{{ statsZone.totalCommandes ?? statsZone.total ?? 0 }}</span>
        <span class="kpi-lbl">Total commandes</span>
      </div>
    </div>
    <div class="kpi-card kpi--orange">
      <i class="fal fa-clock"></i>
      <div class="kpi-body">
        <span class="kpi-val">{{ statsZone.commandesEnAttente ?? intentions.length ?? 0 }}</span>
        <span class="kpi-lbl">En attente</span>
      </div>
    </div>
    <div class="kpi-card kpi--teal">
      <i class="fal fa-truck-moving"></i>
      <div class="kpi-body">
        <span class="kpi-val">{{ statsZone.commandesEnCours ?? commandesEnCours.length ?? 0 }}</span>
        <span class="kpi-lbl">En cours</span>
      </div>
    </div>
    <div class="kpi-card kpi--green">
      <i class="fal fa-check-circle"></i>
      <div class="kpi-body">
        <span class="kpi-val">{{ statsZone.commandesLivrees ?? statsZone.livrees ?? 0 }}</span>
        <span class="kpi-lbl">Livrées</span>
      </div>
    </div>
    <div class="kpi-card kpi--purple">
      <i class="fal fa-file-alt"></i>
      <div class="kpi-body">
        <span class="kpi-val">{{ statsZone.totalManifestes ?? manifestes.length ?? 0 }}</span>
        <span class="kpi-lbl">Manifestes</span>
      </div>
    </div>
    <div class="kpi-card kpi--red" *ngIf="(statsZone.encaissementsNonValides ?? encaissementsAValider.length) > 0">
      <i class="fal fa-coins"></i>
      <div class="kpi-body">
        <span class="kpi-val">{{ statsZone.encaissementsNonValides ?? encaissementsAValider.length }}</span>
        <span class="kpi-lbl">Encaissements à valider</span>
      </div>
    </div>
  </div>

  <!-- Chargement KPIs -->
  <div class="kpi-skeleton" *ngIf="chargementStats">
    <div class="skeleton-card" *ngFor="let i of [1,2,3,4,5]"></div>
  </div>

  <!-- ─── Contenu en deux colonnes ─────────────────────────────── -->
  <div class="zm-grid">

    <!-- ── Colonne gauche : Intentions clients ─────────────────── -->
    <div class="zm-section">
      <div class="section-header">
        <div class="section-header__left">
          <span class="section-icon section-icon--orange"><i class="fal fa-users"></i></span>
          <div>
            <h2 class="section-title">Intentions clients</h2>
            <p class="section-sub">Commandes interurbaines en attente de prise en charge</p>
          </div>
        </div>
        <button class="section-link" (click)="voirToutesInterurbaines()">
          Tout voir <i class="fal fa-arrow-right"></i>
        </button>
      </div>

      <div class="section-loading" *ngIf="chargementIntentions">
        <div class="spinner"></div>
        <span>Chargement…</span>
      </div>

      <div class="section-empty" *ngIf="!chargementIntentions && intentions.length === 0">
        <i class="fal fa-check-circle"></i>
        <span>Aucune intention client en attente — super !</span>
      </div>

      <div class="intentions-list" *ngIf="!chargementIntentions && intentions.length > 0">
        <div class="intention-card" *ngFor="let c of intentions | slice:0:8"
             [class]="'intention-card intention-card--' + (c.statut | lowercase)"
             (click)="voirCommandeDetail(c.id)">

          <div class="intention-card__accent"></div>

          <div class="intention-card__content">
            <div class="intention-card__top">
              <div class="intention-top-left">
                <span class="ref-badge">{{ c.numeroCommande ?? '#' + c.id }}</span>
                <span class="ic-date" *ngIf="c.dateCreation">
                  <i class="fal fa-clock"></i>
                  {{ c.dateCreation | date:'dd/MM HH:mm' }}
                </span>
              </div>
              <span class="statut-badge" [ngClass]="badgeStatut(c.statut)">
                {{ libelleStatut(c.statut) }}
              </span>
            </div>

            <div class="intention-card__parties">
              <div class="ic-partie ic-partie--exp">
                <div class="ic-avatar ic-avatar--exp">
                  {{ (c.expediteur?.nom ?? 'E').charAt(0).toUpperCase() }}
                </div>
                <div class="ic-info">
                  <span class="ic-role">Expéditeur</span>
                  <span class="ic-nom">{{ c.expediteur?.nom ?? '—' }}</span>
                </div>
              </div>
              <div class="ic-arrow">
                <i class="fal fa-arrow-right"></i>
              </div>
              <div class="ic-partie ic-partie--dest">
                <div class="ic-avatar ic-avatar--dest">
                  {{ (c.destinataire?.nom ?? 'D').charAt(0).toUpperCase() }}
                </div>
                <div class="ic-info">
                  <span class="ic-role">Destinataire</span>
                  <span class="ic-nom">{{ c.destinataire?.nom ?? '—' }}</span>
                </div>
              </div>
            </div>

            <div class="intention-card__footer">
              <span class="ic-route" *ngIf="c.trajet">
                <i class="fal fa-map-marker-alt"></i>
                {{ c.trajet?.zoneDepart?.nom ?? '?' }}
                <i class="fal fa-long-arrow-right" style="font-size:10px;opacity:.5"></i>
                {{ c.trajet?.zoneDestination?.nom ?? '?' }}
              </span>
              <span class="ic-montant">
                {{ (c.coutEstime ?? c.montantAPayer ?? 0) | number:'1.0-0' }} F
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="section-more" *ngIf="intentions.length > 8">
        <button (click)="voirToutesInterurbaines()">
          +{{ intentions.length - 8 }} autres commandes en attente
        </button>
      </div>
    </div>

    <!-- ── Colonne droite : Manifestes ─────────────────────────── -->
    <div class="zm-section">
      <div class="section-header">
        <div class="section-header__left">
          <span class="section-icon section-icon--purple"><i class="fal fa-file-alt"></i></span>
          <div>
            <h2 class="section-title">Manifestes</h2>
            <p class="section-sub">Envoyés et reçus pour votre zone</p>
          </div>
        </div>
      </div>

      <div class="section-loading" *ngIf="chargementManifestes">
        <div class="spinner"></div>
        <span>Chargement…</span>
      </div>

      <div class="section-empty" *ngIf="!chargementManifestes && manifestes.length === 0">
        <i class="fal fa-file-alt"></i>
        <span>Aucun manifeste disponible.</span>
      </div>

      <div class="manifestes-list" *ngIf="!chargementManifestes && manifestes.length > 0">
        <div class="manifeste-row" *ngFor="let m of manifestes">
          <div class="manifeste-row__ref">
            <i class="fal fa-file-invoice"></i>
            <div>
              <strong>{{ m.numeroReference ?? '#' + m.id }}</strong>
              <small>{{ m.dateExpedition | date:'dd/MM/yyyy HH:mm' }}</small>
            </div>
          </div>
          <div class="manifeste-row__trajet">
            <span class="ct-depart">{{ m.centreTriDepart?.nom ?? '—' }}</span>
            <i class="fal fa-long-arrow-right"></i>
            <span class="ct-arrivee">{{ m.centreTriArrivee?.nom ?? '—' }}</span>
          </div>
          <div class="manifeste-row__info">
            <span class="colis-count">
              <i class="fal fa-boxes"></i> {{ m.nombreTotalColis ?? '?' }} colis
            </span>
          </div>
          <span class="statut-badge" [ngClass]="badgeManifeste(m.statut ?? m.status)">
            {{ libelleStatutManifeste(m.statut ?? m.status) }}
          </span>
        </div>
      </div>
    </div>

  </div><!-- end zm-grid -->

  <!-- ─── Commandes en cours ────────────────────────────────────── -->
  <div class="zm-section zm-section--full" *ngIf="commandesEnCours.length > 0">
    <div class="section-header">
      <div class="section-header__left">
        <span class="section-icon section-icon--teal"><i class="fal fa-truck-moving"></i></span>
        <div>
          <h2 class="section-title">En cours de livraison</h2>
          <p class="section-sub">Commandes actives dans votre zone</p>
        </div>
      </div>
      <button class="section-link" (click)="voirToutesInterurbaines()">
        Tout voir <i class="fal fa-arrow-right"></i>
      </button>
    </div>
    <div class="en-cours-table">
      <table>
        <thead>
          <tr>
            <th>Référence</th>
            <th>Expéditeur → Destinataire</th>
            <th>Statut</th>
            <th>Livreur</th>
            <th>Montant</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of commandesEnCours | slice:0:10" (click)="voirCommandeDetail(c.id)">
            <td><span class="ref-badge">{{ c.numeroCommande ?? '#' + c.id }}</span></td>
            <td>{{ c.expediteur?.nom ?? '—' }} → {{ c.destinataire?.nom ?? '—' }}</td>
            <td>
              <span class="statut-badge" [ngClass]="badgeStatut(c.statut)">{{ libelleStatut(c.statut) }}</span>
            </td>
            <td>{{ c.livreur ? (c.livreur.prenom + ' ' + c.livreur.nom) : '—' }}</td>
            <td>{{ (c.coutEstime ?? c.montantAPayer ?? 0) | number:'1.0-0' }} F</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- ─── Encaissements à valider ──────────────────────────────── -->
  <div class="zm-section zm-section--full encaissement-section"
       *ngIf="encaissementsAValider.length > 0">
    <div class="section-header">
      <div class="section-header__left">
        <span class="section-icon section-icon--red"><i class="fal fa-coins"></i></span>
        <div>
          <h2 class="section-title">Encaissements à valider</h2>
          <p class="section-sub">Paiements confirmés par les livreurs mais non encore validés</p>
        </div>
      </div>
    </div>
    <div class="enc-list">
      <div class="enc-card" *ngFor="let c of encaissementsAValider | slice:0:6"
           (click)="voirCommandeDetail(c.id)">
        <div class="enc-card__top">
          <span class="ref-badge">{{ c.numeroCommande ?? '#' + c.id }}</span>
          <span class="enc-mode">{{ c.modeEncaissement ?? '—' }}</span>
        </div>
        <div class="enc-card__amount">{{ (c.montantCashEncaisse ?? 0) | number:'1.0-0' }} F</div>
        <div class="enc-card__livreur" *ngIf="c.livreur">
          <i class="fal fa-user-hard-hat"></i>
          {{ c.livreur.prenom }} {{ c.livreur.nom }}
        </div>
      </div>
    </div>
  </div>

</div>
